export const prefix = process.env.NEXT_PUBLIC_IS_STAGING
    ? 'https://mxlocker-staging.b-cdn.net'
    : 'https://cdn.mxlocker.com';